module.exports = __webpack_public_path__ + "static/img/no11.d1caa86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bannerbottom/no11.png
// module id = PPxT
// module chunks = 31